<template>
  <div class="step2">
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="courseType === 'live'? 'primary' : 'default'"
          @click="switchBtnHandler('live')"
        >
          直播课程
        </el-button>
        <el-button
          :type="courseType === 'preJob' ? 'primary' : 'default'"
          @click="switchBtnHandler('preJob')"
        >
          岗前培训
        </el-button>
      </el-button-group>
    </div>
    <form-title>课程信息</form-title>
    <info-panel class="info">
      <el-row>
        <el-col
          class="info-item"
          :xl="6"
          :lg="20"
        >
          <span>
            课程名称:
          </span>
          <span>{{ info.courseName }}</span>
        </el-col>
        <el-col
          class="info-item"
          :xl="6"
          :lg="20"
        >
          <span>
            课程类型:
          </span>
          <span>{{ info.courseCategoryName }}</span>
        </el-col>
        <el-col
          class="info-item"
          :xl="6"
          :lg="20"
        >
          <span>
            课程简介:
          </span>
          <span>{{ info.courseSimpleIntro }}</span>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>基本信息</form-title>
    <el-form
      ref="creatStep2Form"
      :model="creatStep2Form"
      :rules="creatStep2Rules"
      label-width="120px"
    >
      <info-panel>
        <el-row :gutter="20">
          <el-col
            :xl="6"
            :md="12"
            :lg="8"
          >
            <el-form-item
              label="主讲老师"
              prop="teacherList"
            >
              <el-select
                v-model="creatStep2Form.teacherList"
                multiple
                filterable
                clearable
                placeholder="请选择主讲老师"
              >
                <el-option
                  v-for="item in teacherList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="排序值"
              prop="rank"
            >
              <el-input v-model="creatStep2Form.rank" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="视频考试数量"
              prop="videoExamCount"
              class="input-flex"
            >
              <el-input v-model="creatStep2Form.videoExamCount" />
              <el-tooltip
                effect="dark"
                content="-1代表按章节走"
                placement="top-start"
              >
                <i class="el-icon-question" />
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="课程价格"
              prop="coursePrice"
            >
              <el-input
                v-model="creatStep2Form.coursePrice"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="虚拟价格"
              prop="fakePrice"
            >
              <el-input
                v-model="creatStep2Form.fakePrice"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="虚拟价格标签"
              prop="priceTag"
            >
              <el-input v-model="creatStep2Form.priceTag" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="考试类型"
              prop="examType"
            >
              <el-select
                v-model="creatStep2Form.examType"
                placeholder="考试类型"
                filterable
                clearable
              >
                <el-option
                  v-for="item in examTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="虚拟报名数"
              prop="virtualRegistrationCount"
            >
              <el-input v-model="creatStep2Form.virtualRegistrationCount" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="证书编号"
              prop="certNo"
            >
              <el-input v-model="creatStep2Form.certNo" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item
              label="课程详情"
              prop="courseDesc"
            >
              <editor :html.sync="creatStep2Form.courseDesc" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="封面图"
              prop="courseCoverPic"
            >
              <upload :file-list.sync="creatStep2Form.courseCoverPic" />
              <el-input
                v-show="false"
                v-model="creatStep2Form.courseCoverPic"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="小程序Icon"
              prop="mpIcon"
            >
              <upload
                :file-list.sync="creatStep2Form.mpIcon"
                :auto-crop-width="64"
                :auto-crop-height="64"
              />
              <el-input
                v-show="false"
                v-model="creatStep2Form.mpIcon"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="小程序Icon选中状态"
              prop="mpIconClick"
            >
              <upload
                :file-list.sync="creatStep2Form.mpIconClick"
                :auto-crop-width="64"
                :auto-crop-height="64"
              />
              <el-input
                v-show="false"
                v-model="creatStep2Form.mpIconClick"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </info-panel>
      <form-title>
        分享设置
      </form-title>
      <info-panel>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="课程分享类型"
              prop="shareType"
            >
              <el-radio-group v-model="creatStep2Form.shareType">
                <el-radio :label="1">
                  葵花码
                </el-radio>
                <el-radio :label="2">
                  自定义图片
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            v-if="creatStep2Form.shareType === 2"
            :md="12"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="葵花码宽度(px)"
              prop="shareCodeWidth"
            >
              <el-input
                v-model="creatStep2Form.shareCodeWidth"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="creatStep2Form.shareType === 2"
            :md="12"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="葵花码高度(px)"
              prop="shareCodeHeight"
            >
              <el-input
                v-model="creatStep2Form.shareCodeHeight"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="creatStep2Form.shareType === 2"
            :md="12"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="葵花码x轴起点(px)"
              prop="shareCodeX"
            >
              <el-input
                v-model="creatStep2Form.shareCodeX"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="creatStep2Form.shareType === 2"
            :md="12"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="葵花码y轴起点(px)"
              prop="shareCodeY"
            >
              <el-input
                v-model="creatStep2Form.shareCodeY"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="creatStep2Form.shareType === 2"
            :md="12"
            :lg="8"
            :xl="4"
          >
            <el-form-item
              label="自定义图片地址"
              prop="shareCustomizePicUrl"
            >
              <upload
                :file-list.sync="creatStep2Form.shareCustomizePicUrl"
              />
              <el-input
                v-show="false"
                v-model="creatStep2Form.shareCustomizePicUrl"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="creatStep2Form.shareType === 2"
            :span="24"
          >
            <div class="btns">
              <el-button
                type="primary"
                @click="shareTest"
              >
                查看分享码
              </el-button>
            </div>
          </el-col>
        </el-row>
      </info-panel>
      <form-title>分销设置</form-title>
      <info-panel>
        <el-row :gutter="20">
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="平台分销金额"
              prop="platformDistributionAmount"
            >
              <el-input
                v-model="creatStep2Form.platformDistributionAmount"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="机构分销金额"
              prop="agencyDistributionAmount"
            >
              <el-input
                v-model="creatStep2Form.agencyDistributionAmount"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="平台代辅导金额"
              prop="counselingAmount"
            >
              <el-input
                v-model="creatStep2Form.counselingAmount"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="老师分销金额"
              prop="teacherAmount"
            >
              <el-input
                v-model="creatStep2Form.teacherAmount"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="视频审核金额"
              prop="videoReviewAmount"
            >
              <el-input
                v-model="creatStep2Form.videoReviewAmount"
                class="append-unit"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </info-panel>
      <form-title>理论考试-出题规则</form-title>
      <info-panel>
        <el-row :gutter="20">
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="判断题数量"
              prop="judgmentCount"
            >
              <el-input
                v-model="creatStep2Form.judgmentCount"
                class="append-unit"
              >
                <template slot="append">
                  个
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="判断题分数"
              prop="judgmentScore"
            >
              <el-input
                v-model="creatStep2Form.judgmentScore"
                class="append-unit"
              >
                <template slot="append">
                  分
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="选择题个数"
              prop="choiceCount"
            >
              <el-input
                v-model="creatStep2Form.choiceCount"
                class="append-unit"
              >
                <template slot="append">
                  个
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :md="12"
            :lg="8"
            :xl="6"
          >
            <el-form-item
              label="选择题分数"
              prop="choiceScore"
            >
              <el-input
                v-model="creatStep2Form.choiceScore"
                class="append-unit"
              >
                <template slot="append">
                  分
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </info-panel>
      <form-title>备注信息</form-title>
      <info-panel>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="备注信息"
              prop="remark"
            >
              <el-input
                v-model="creatStep2Form.remark"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </info-panel>
      <el-row :gutter="20">
        <el-col class="btns">
          <el-button @click="prev">
            上一步
          </el-button>
          <el-button
            type="primary"
            @click="next"
          >
            {{ submitText }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="creatStep2Form.id">
      <chapter
        :id="creatStep2Form.id"
        :chapter-list="chapterList"
        @listChapter="listChapter"
      />
      <schedule
        ref="schedule"
        :course-id="creatStep2Form.id"
        :chapter-list="chapterList"
      />
    </div>
    <courseShareTestDialog
      :share-test-url="shareTestUrl"
      :dialog-visible.sync="shareTestVisible"
      @confirm="confirmUpdateShareQrCodeUrl()"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import Editor from '@/components/common/editor.vue';
import axClient from '@/services';
import types, { examTypeList } from '@/config';
import upload from '@/components/common/upload/upload.vue';
import courseShareTestDialog from '@/components/common/courseShareTestDialog.vue';
import chapter from './chapter/index.vue';
import schedule from './schedule/index.vue';

export default {
  name: 'CreatStep1',
  components: {
    infoPanel, formTitle, chapter, schedule, upload, Editor, courseShareTestDialog,
  },
  props: {
    info: {
      default: () => ({
        courseName: '',
        courseCategoryName: '',
        courseSimpleIntro: '',
      }),
      type: Object,
    },
    form: {
      default: null,
      type: Object || null,
    },
    courseType: {
      default: 'live',
      type: String,
    },
  },
  data() {
    return {
      isEdit: !!this.$route.params.courseClassId,
      editor: null,
      teacherList: [],
      shareTestVisible: false,
      chapterList: [],
      examTypeList: this._.cloneDeep(examTypeList),
      shareTestUrl: '',
      creatStep2Form: {
        id: null,
        courseDesc: null,
        courseCoverPic: null,
        mpIcon: null,
        mpIconClick: null,
        remark: null,
        rank: null,
        videoExamCount: null,
        certNo: null,
        teacherList: [],
        coursePrice: null,
        virtualRegistrationCount: null,
        platformDistributionAmount: null,
        agencyDistributionAmount: null,
        counselingAmount: null,
        videoReviewAmount: null,
        teacherAmount: null,
        examType: null,
        valid: types.COURSE_DISABLE,
        // 分享的设置放在原来的表单里面
        shareType: null, // 课程分享类型(1:葵花码，2：自定义图片)
        shareCustomizePicUrl: null, // 分享自定义图片地址
        shareCodeX: null, // 葵花码x轴起点
        shareCodeY: null, // 葵花码y轴起点
        shareCodeWidth: null, // 葵花码宽度
        shareCodeHeight: null, // 葵花码高度
      },
      creatStep2Rules: {
        teacherList: [
          { required: true, message: '请选择主讲老师', trigger: 'blur' },
        ],
        examType: [
          { required: true, message: '请选择考试类型', trigger: 'blur' },
        ],
        coursePrice: [
          {
            required: true, message: '请输入课程价格', trigger: 'blur',
          },
        ],
        certNo: [
          {
            required: true, message: '请输入证书编号', trigger: 'blur',
          },
          {
            min: 2, max: 2, message: '编号长度2位', trigger: 'blur',
          },
        ],
        platformDistributionAmount: [
          { required: true, message: '请输入平台分销金额', trigger: 'blur' },
        ],
        virtualRegistrationCount: [
          { required: true, message: '请输入虚拟报名数', trigger: 'blur' },
        ],
        agencyDistributionAmount: [
          { required: true, message: '请输入机构分销金额', trigger: 'blur' },
        ],
        counselingAmount: [
          { required: true, message: '请输入平台代辅导金额', trigger: 'blur' },
        ],
        videoReviewAmount: [
          { required: true, message: '请输入视频审核金额', trigger: 'blur' },
        ],
        teacherAmount: [
          { required: true, message: '请输入老师分销金额', trigger: 'blur' },
        ],
        judgmentCount: [
          { required: true, message: '请输入判断题个数', trigger: 'blur' },
        ],
        choiceCount: [
          { required: true, message: '请输入选择题个数', trigger: 'blur' },
        ],
        choiceScore: [
          { required: true, message: '请输入选择题分数', trigger: 'blur' },
        ],
        judgmentScore: [
          { required: true, message: '请输入判断题分数', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    submitText() {
      const type = {
        live: '直播课程',
        preJob: '岗前课程',
      };
      if (this.creatStep2Form.id) {
        return `保存${type[this.courseType]}课程`;
      }
      return `创建${type[this.courseType]}`;
    },
  },
  watch: {
    courseType() {
      setTimeout(() => {
        this.creatStep2Form = { ...this.form };
        this.listChapter(); // 查询章节
      });
    },
  },
  mounted() {
    this.examTypeList.shift();
    if (this.isEdit) {
      this.creatStep2Form = { ...this.form };
      this.courseGetShare();
    }
    this.initList();
  },
  methods: {
    // 测试生成的分享码
    async shareTest() {
      const data = await axClient.course.courseShareTest(
        {
          courseId: this.creatStep2Form.id,
          shareType: this.creatStep2Form.shareType,
          shareCustomizePicUrl: this.creatStep2Form.shareCustomizePicUrl,
          shareCodeX: this.creatStep2Form.shareCodeX,
          shareCodeY: this.creatStep2Form.shareCodeY,
          shareCodeWidth: this.creatStep2Form.shareCodeWidth,
          shareCodeHeight: this.creatStep2Form.shareCodeHeight,
        },
      );
      if (data) {
        this.shareTestUrl = data;
        this.shareTestVisible = true;
      }
    },
    // 测试生成的分享码
    async confirmUpdateShareQrCodeUrl() {
      const data = await axClient.course.updateShareQrCodeUrl(
        {
          courseId: this.creatStep2Form.id,
          shareType: this.creatStep2Form.shareType,
          shareCustomizePicUrl: this.creatStep2Form.shareCustomizePicUrl,
          shareCodeX: this.creatStep2Form.shareCodeX,
          shareCodeY: this.creatStep2Form.shareCodeY,
          shareCodeWidth: this.creatStep2Form.shareCodeWidth,
          shareCodeHeight: this.creatStep2Form.shareCodeHeight,
        },
      );
      if (data) {
        this.$message.success('修改成功');
        this.shareTestVisible = false;
      }
    },
    // get editor html
    getEditor(html) {
      this.creatStep2Form.courseDesc = html;
    },
    // 查询章节
    async listChapter() {
      if (this.creatStep2Form.id) {
        this.chapterList = await axClient.course.listChapter(this.creatStep2Form.id);
      }
    },
    // 切换显示机构人员
    switchBtnHandler(val) {
      if (this.courseType === val) return;
      this.$emit('update', this._.cloneDeep(this.creatStep2Form));
      this.$emit('update:courseType', val);
      setTimeout(() => {
        if (this.form) {
          this.creatStep2Form = { ...this.form };
        } else {
          this.$refs.creatStep2Form.resetFields();
          if (this.editor) {
            this.editor.txt.clear();
          }
        }
      });
    },
    // 上一步
    prev() {
      this.$emit('prev', 1);
    },
    // 下一步
    next() {
      this.$refs.creatStep2Form.validate(async (valid) => {
        if (valid) {
          this.$emit('next', this.creatStep2Form);
        }
      });
    },
    // 查询老师
    async initList() {
      this.teacherList = await axClient.course.listTeacher();
      this.listChapter();
    },
    // 查询课程分享
    async courseGetShare() {
      if (this.form) {
        const shareInfo = await axClient.course.courseGetShare({ id: this.form.id });
        const {
          shareType, shareCustomizePicUrl, shareCodeX, shareCodeY,
          shareCodeWidth, shareCodeHeight,
        } = shareInfo;
        this.creatStep2Form = {
          ...this.creatStep2Form,
          shareType,
          shareCustomizePicUrl,
          shareCodeX,
          shareCodeY,
          shareCodeWidth,
          shareCodeHeight,
        };
        this.listChapter();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.step2 {
  padding-bottom: 100px;
  .info {
    display: flex;
    align-items: center;
    color: $--base-color-black;
    font-size: 14px;
    margin-bottom: 20px;
    .info-item {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      span {
        min-width: 80px;
        &:last-child {
          color: $--base-color-main;
          margin-left: 20px;
        }
      }
    }
  }
  .btns {
    padding-top: 20px;
  }
  .flex {
    justify-content: space-between;
    .switch-btns {
      padding-top: 12px;
    }
  }
}
</style>
